import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    ClientName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    SiteName: {
      validations: []
    },
    StartTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Operation: {
      validations: []
    },
    Category: {
      validations: []
    },
    BusType: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Business Affiliation (If Applicable)',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event:*',
            options: [
              { label: 'Baby Shower'  , value: 'Baby Shower'},
              { label: 'Bar/Bat Mitzvah'  , value: 'Bar/Bat Mitzvah'},
              { label: 'Birthday Party'  , value: 'Birthday Party'},
              { label: 'Breakfast/Brunch'  , value: 'Breakfast/Brunch'},
              { label: 'Bridal Shower'  , value: 'Bridal Shower'},
              { label: 'Celebration of Life/Memorial/Funeral'  , value: 'Celebration of Life/Memorial/Funeral'},
              { label: 'Cooking Class'  , value: 'Cooking Class'},
              { label: 'Graduation Party'  , value: 'Graduation Party'},
              { label: 'Office Breakfast'  , value: 'Office Breakfast'},
              { label: 'Office Dinner'  , value: 'Office Dinner'},
              { label: 'Office Lunch'  , value: 'Office Lunch'},
              { label: 'Open House'  , value: 'Open House'},
              { label: 'Other'  , value: 'Other'},
              { label: 'Wedding Reception'  , value: 'Wedding Reception'},
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Event Location:',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Projected Time of Event:*',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'StartTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'I am interested in the following food services for my event (please check all that apply):',
            options: [
              { label: 'Buffet Style', value: 'Buffet Style'},
              { label: 'Strolling Appetizers/Finger Food Entrees', value: 'Strolling Appetizers/Finger Food Entrees'},
              { label: 'Breakfast/Brunch', value: 'Linen'},
              { label: 'Boxed Lunches/Deli Luncheon', value: 'Plating'},
              { label: 'Entrees(s)', value: 'Silverware'},
              { label: 'Dessert(s)', value: 'Tables and/or Chairs'},
              { label: 'Appetizer(s)', value: 'Cake Cutting'},
              { label: 'Salad(s)', value: 'Dishwashing'},
              { label: 'Pasta(s)', value: 'Other'},
              { label: 'Sides', value: 'Tables and/or Chairs'},
              { label: 'Family Style', value: 'Cake Cutting'},
              { label: 'Elegant Plated Dinners', value: 'Dishwashing'},
              { label: 'Late Night Fun Food Bars', value: 'Other'},
              { label: 'Beverage Service', value: 'Other'},
            ],
            mapping: 'Operation',
            customClasses: ['check-columns']
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'I am interested in the following additional event rentals offered by Celebrity Catering:',
            options: [
              { label: 'Tables', value: 'Tables'},
              { label: 'Chairs', value: 'Chairs'},
              { label: 'Linens', value: 'Linens'},
              { label: 'Dishware', value: 'Dishware'},
              { label: 'Glassware', value: 'Glassware'},
              { label: 'Silverware', value: 'Silverware'},
              { label: 'Tents', value: 'Tents'},
            ],
            mapping: 'Category',
            customClasses: ['check-columns']
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Celebrity Catering partners with a group of trusted reliable vendors to provide the following additional event services. Please check any services you wish to receive addtional information in your quote for:',
            options: [
              { label: 'DJ', value: 'DJ'},
              { label: 'Photobooth', value: 'Photobooth'},
              { label: 'Event Planner', value: 'Event Planner'},
              { label: 'Bartenders', value: 'Bartenders'},
              { label: 'Food Servers/Attendants', value: 'Food Servers/Attendants'},
              { label: 'Portable Restrooms Onsite', value: 'Portable Restrooms Onsite'},
              { label: 'Wedding Officiant', value: 'Wedding Officiant'},
            ],
            mapping: 'BusType',
            customClasses: ['check-columns']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Information/Questions:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Thank you for providing the above information that will allow a dedicated member of our team to create an accurate custom quote for your event!',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Send Me a Quote!'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Celebrity Catering Contact Us Form',
    formId: '712',
    clientKey: '8BE526C0-5C86-495A-BEE9-8D1D48525E8D',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
